import React, { useEffect } from 'react'
import { InputModal } from '../InputModal'
import { ShareIcon } from '../Icon'
import './youtube-embed-modal.scss'

type YoutubeEmbedModalProps = {
  videoId: string
  isOpen: boolean
  onClose: () => void
  title?: string
  testId?: string
  modalClassName?: string
  onShare?: () => void
}

const YoutubeEmbedModal = ({
  videoId,
  isOpen,
  onClose,
  title = 'YouTube video player',
  testId = 'youtube-embed-modal',
  modalClassName = 'youtube-embed-modal__input-modal',
  onShare,
}: YoutubeEmbedModalProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [isOpen])

  if (!isOpen || !videoId.trim()) {
    return null
  }

  return (
    <InputModal testId={testId} className={modalClassName}>
      <div className='youtube-embed-modal__overlay' onClick={onClose}>
        <div className='youtube-embed-modal__content' onClick={(e) => e.stopPropagation()}>
          {onShare && (
            <button
              type='button'
              className='youtube-embed-modal__share'
              onClick={onShare}
              aria-label='Share webinar link'
              data-testid={`${testId}-share`}
            >
              <ShareIcon width='20' height='20' />
            </button>
          )}
          <button
            type='button'
            className='youtube-embed-modal__close'
            onClick={onClose}
            aria-label='Close video'
          >
            ×
          </button>
          <div className='youtube-embed-modal__frame'>
            <iframe
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
              title={title}
              frameBorder='0'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
              referrerPolicy='strict-origin-when-cross-origin'
              allowFullScreen
              loading='lazy'
            />
          </div>
        </div>
      </div>
    </InputModal>
  )
}

export { YoutubeEmbedModal }
